var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "daisy-chain",
        {
          "llp-experiment": !!_vm.isInLLPNuxRecsExperiment,
          mobile: _vm.isMobile(_vm.$mq)
        }
      ]
    },
    [
      _c("p", { staticClass: "label" }, [_vm._v("Up next")]),
      _vm._v(" "),
      _vm.isInLLPNuxRecsExperiment
        ? _c(
            "div",
            { staticClass: "card" },
            [
              !_vm.isMobile(_vm.$mq)
                ? _c("CardBackground", {
                    attrs: { "learning-path": _vm.learningPath }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "learning-path" }, [
                  _vm.isMobile(_vm.$mq)
                    ? _c(
                        "div",
                        { staticClass: "image" },
                        [
                          _c("BriocheBackgroundImage", {
                            attrs: { src: _vm.learningPath.image, width: 136 }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "track",
                          rawName: "v-track:click",
                          value: {
                            axId: "clicked_up_next_learning_path",
                            axExtra: {
                              learning_path: _vm.learningPath.slug
                            }
                          },
                          expression:
                            "{\n            axId: 'clicked_up_next_learning_path',\n            axExtra: {\n              learning_path: learningPath.slug,\n            },\n          }",
                          arg: "click"
                        }
                      ],
                      staticClass: "link",
                      attrs: { href: _vm.learningPath.url }
                    },
                    [
                      _c("h3", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.learningPath.title))
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "track",
                        rawName: "v-track:click",
                        value: {
                          axId: "clicked_up_next_learning_path",
                          axExtra: {
                            learning_path: _vm.learningPath.slug
                          }
                        },
                        expression:
                          "{\n          axId: 'clicked_up_next_learning_path',\n          axExtra: {\n            learning_path: learningPath.slug,\n          },\n        }",
                        arg: "click"
                      }
                    ],
                    staticClass: "link",
                    attrs: { href: _vm.learningPath.url }
                  },
                  [
                    _c("h6", { staticClass: "level" }, [
                      _vm._v(
                        "Level " +
                          _vm._s(_vm.nextLearningPathCourse.level_number)
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "track",
                        rawName: "v-track:click",
                        value: {
                          axId: "clicked_up_next_visit_course",
                          axExtra: {
                            up_next_course_slug:
                              _vm.nextLearningPathCourse.course.slug
                          }
                        },
                        expression:
                          "{\n          axId: 'clicked_up_next_visit_course',\n          axExtra: {\n            up_next_course_slug: nextLearningPathCourse.course.slug,\n          },\n        }",
                        arg: "click"
                      }
                    ],
                    staticClass: "link",
                    attrs: { href: _vm.courseHref }
                  },
                  [
                    _c("h4", { staticClass: "name" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.nextLearningPathCourse.level_number) +
                          "." +
                          _vm._s(_vm.nextCoursePosition) +
                          "\n          " +
                          _vm._s(_vm.nextLearningPathCourse.course.name) +
                          "\n        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "description" }, [
                  _vm._v(_vm._s(_vm.nextLearningPathCourse.course.intro_text))
                ]),
                _vm._v(" "),
                _vm.hasProgress
                  ? _c(
                      "div",
                      { staticClass: "progress-bar-container" },
                      [
                        _c("ProgressBar", {
                          attrs: {
                            "completion-percentage": _vm.percentComplete
                          }
                        }),
                        _vm._v(" "),
                        _vm.isCourseComplete
                          ? _c("CircleCheckMarkIcon", {
                              staticClass: "completed-check"
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "track",
                        rawName: "v-track:click",
                        value: {
                          axId: "clicked_up_next_visit_course",
                          axExtra: {
                            up_next_course_slug:
                              _vm.nextLearningPathCourse.course.slug
                          }
                        },
                        expression:
                          "{\n          axId: 'clicked_up_next_visit_course',\n          axExtra: {\n            up_next_course_slug: nextLearningPathCourse.course.slug,\n          },\n        }",
                        arg: "click"
                      }
                    ],
                    staticClass: "cta",
                    attrs: { href: _vm.courseHref }
                  },
                  [_vm._v("\n        Visit course\n      ")]
                )
              ])
            ],
            1
          )
        : [
            !_vm.isMobile(_vm.$mq)
              ? _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "info" },
                    [
                      _c("LearningPathPill", {
                        attrs: { "learning-path": _vm.learningPathForPill }
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.nextLearningPathCourse.course.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "description" }, [
                        _vm._v(
                          _vm._s(_vm.nextLearningPathCourse.course.intro_text)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.hasProgress
                        ? _c(
                            "div",
                            { staticClass: "progress-bar-container" },
                            [
                              _c("ProgressBar", {
                                attrs: {
                                  "completion-percentage": _vm.percentComplete
                                }
                              }),
                              _vm._v(" "),
                              _vm.isCourseComplete
                                ? _c("CircleCheckMarkIcon", {
                                    staticClass: "completed-check"
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:click",
                              value: {
                                axId: "clicked_up_next_visit_course",
                                axExtra: {
                                  up_next_course_slug:
                                    _vm.nextLearningPathCourse.course.slug
                                }
                              },
                              expression:
                                "{\n            axId: 'clicked_up_next_visit_course',\n            axExtra: {\n              up_next_course_slug: nextLearningPathCourse.course.slug,\n            },\n          }",
                              arg: "click"
                            }
                          ],
                          staticClass: "cta",
                          attrs: { href: _vm.courseHref }
                        },
                        [_vm._v("\n          Visit course\n        ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "image",
                    attrs: {
                      src: _vm.nextLearningPathCourse.course.image_url,
                      alt: ""
                    }
                  })
                ])
              : _c(
                  "div",
                  { staticClass: "card" },
                  [
                    _c("div", { staticClass: "title-and-image" }, [
                      _c("h3", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.nextLearningPathCourse.course.name))
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "image",
                        attrs: {
                          src: _vm.nextLearningPathCourse.course.image_url,
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("LearningPathPill", {
                      staticClass: "llp-pill",
                      attrs: { "learning-path": _vm.learningPathForPill }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        _vm._s(_vm.nextLearningPathCourse.course.intro_text)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.hasProgress
                      ? _c(
                          "div",
                          { staticClass: "progress-bar-container" },
                          [
                            _c("ProgressBar", {
                              attrs: {
                                "completion-percentage": _vm.percentComplete
                              }
                            }),
                            _vm._v(" "),
                            _vm.isCourseComplete
                              ? _c("CircleCheckMarkIcon", {
                                  staticClass: "completed-check"
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: {
                              axId: "clicked_up_next_visit_course",
                              axExtra: {
                                up_next_course_slug:
                                  _vm.nextLearningPathCourse.course.slug
                              }
                            },
                            expression:
                              "{\n          axId: 'clicked_up_next_visit_course',\n          axExtra: {\n            up_next_course_slug: nextLearningPathCourse.course.slug,\n          },\n        }",
                            arg: "click"
                          }
                        ],
                        staticClass: "cta",
                        attrs: {
                          href:
                            "/courses/" + _vm.nextLearningPathCourse.course.slug
                        }
                      },
                      [_vm._v("\n        Visit course\n      ")]
                    )
                  ],
                  1
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }